export const PO_TYPE = [{ label: 'B2B', value: 'b2b' }];

export const PO_SHIPPING_TYPE = [
  { label: 'Air', value: 'air' },
  { label: 'Road', value: 'road' },
  { label: 'Sea', value: 'sea' },
];
